import orgApiV4 from "src/api/clients/org-api-v4";
import { NotificationSearchState } from "src/features/notifications/shared/types/payloads/notification-search-state.payload";
import { UpdateTenantNotificationsSettingsPayload } from "src/features/notifications/shared/types/payloads/update-notifications-settings.payload";
import { NotificationI } from "src/features/notifications/shared/types/responses/notification.response";
import { NotificationsSettings } from "src/features/notifications/shared/types/responses/notifications-settings.response";
import { PaginatedDataV4 } from "src/types/responses/paginated-data-v4";

class TenantNotificationsApi {
  //NOTIFICATIONS SETTINGS
  async fetchNotificationsSettings(): Promise<NotificationsSettings> {
    const { data } = await orgApiV4.get<NotificationsSettings>("/notifications/settings");

    return data;
  }

  async updateNotificationsSettings(
    payload: UpdateTenantNotificationsSettingsPayload,
  ): Promise<void> {
    await orgApiV4.put<void>(`/notifications/settings`, payload);
  }

  //NOTIFICATIONS
  async fetchNotifications(
    page: number,
    perPage: number,
    { search, lang, dateFrom, dateTo, read }: NotificationSearchState,
  ): Promise<PaginatedDataV4<NotificationI>> {
    const { data } = await orgApiV4.get<PaginatedDataV4<NotificationI>>("/notifications", {
      params: {
        page,
        perPage,
        ...(search ? { search } : {}),
        ...(lang ? { lang } : {}),
        ...(dateFrom ? { dateFrom } : {}),
        ...(dateTo ? { dateTo } : {}),
        ...(typeof read === "boolean" ? { read } : {}),
      },
    });
    return data;
  }

  async markSingleNotificationAsRead(notificationToken: string): Promise<{ updatedCount: number }> {
    const { data } = await orgApiV4.patch(`/notifications/${notificationToken}/read`);
    return data;
  }
  async markSingleNotificationAsUnread(
    notificationToken: string,
  ): Promise<{ updatedCount: number }> {
    const { data } = await orgApiV4.patch(`/notifications/${notificationToken}/unread`);
    return data;
  }
  async markNotificationsAsRead(notificationsTokens: string[]): Promise<{ updatedCount: number }> {
    const { data } = await orgApiV4.patch("/notifications/read", {
      tokens: notificationsTokens,
    });

    return data;
  }
  async markAllNotificationsAsRead(filter: {
    search: string;
    dateFrom: string;
    dateTo: string;
  }): Promise<{ updatedCount: number }> {
    const { data } = await orgApiV4.patch("notifications/read-all", {
      filter,
    });

    return data;
  }
}

export const tenantNotificationsApi = new TenantNotificationsApi();
